import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppEnvironmentState {
  isApp: boolean;
}

// helper to reliably determine initial state
const getInitialIsApp = (): boolean => {
  if (typeof window === 'undefined') return false;

  // first priority what SSR engine injects
  const ssrEnv = (window as unknown as { __INITIAL_APP_ENV__?: { isApp: boolean } }).__INITIAL_APP_ENV__;
  if (ssrEnv && typeof ssrEnv.isApp === 'boolean') {
    return ssrEnv.isApp;
  }

  // fallback if cookie not in ssr read from client
  if (typeof document !== 'undefined') {
    return document.cookie.split(';').some((item) => item.trim() === 'bsApp=true');
  }

  return false;
};

const initialState: AppEnvironmentState = {
  isApp: getInitialIsApp(),
};

export const appEnvironmentSlice = createSlice({
  name: 'appEnvironment',
  initialState,
  reducers: {
    setEnvironment: (state, action: PayloadAction<{ isApp: boolean }>) => {
      state.isApp = action.payload.isApp;
    },
  },
});

export const { setEnvironment } = appEnvironmentSlice.actions;
export default appEnvironmentSlice.reducer;